import Keycloak from "keycloak-js";
const keycloak = new Keycloak({
 url: "https://keycloak.holdingthedrones.com",
 realm: "HoldingTheDrones",
 clientId: "DroneSora3",
//  onLoad: 'check-sso', // check-sso | login-required
//  KeycloakResponseType: 'code',
});

export default keycloak;